<template>
<div class="card-item"
  :id="item.itemId">
  <div class="card-item-heading">{{ item.heading }}</div>
  <div class="card-item-content">
    <div class="input-item">
      <label for="">タイトル</label>
      <Input placeholder="タイトル"
        v-model="item.data.title" />
    </div>
    <div class="input-item">
      <label for="">サブタイトル</label>
      <Input placeholder="サブタイトル"
        v-model="item.data.subTitle" />
    </div>
    <!--
    <div class="input-item">
      <label for="">ロゴ画像</label>
      <Button icon="ios-image-outline">画像をアップロード</Button>
    </div>
  -->
    <div class="input-item">
      <label for="">名義（法人 / 個人）</label>
      <RadioGroup v-model="item.data.companyFormat">
        <Radio label="corporation">{{ $planConfig.companyFormatList.corporation }}</Radio>
        <Radio label="freelance">{{ $planConfig.companyFormatList.freelance }}</Radio>
      </RadioGroup>
    </div>
    <div class="input-item"
      v-if="item.data.companyFormat === 'corporation'">
      <label for="">会社名</label>
      <Input placeholder="株式会社○○"
        v-model="item.data.companyName" />
    </div>
    <div class="input-item">
      <label for="">氏名</label>
      <Input placeholder="氏名"
        v-model="item.data.authorName" />
    </div>
    <div class="input-item">
      <label for="">作成日</label>
      <DatePicker v-model="item.data.createDate"
        format="yyyy年MM月dd日"
        type="date"
        placeholder="Select date"></DatePicker>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
